























import Vue from 'vue'
import SpeciesFormattedNumberInput from '@/UI/AuctionB/Declarations/OfferTable/SpeciesFormattedNumberInput.vue'
import StringifiedNumberInput from '@/UI/Shared/StringifiedNumberInput.vue'
import { Offer } from '@/Infrastructure/Store/AuctionB/Offer'
import InfoTooltip from '@/UI/Shared/InfoTooltip.vue'
import { CurrencyWords } from '@/Domain/Batch/CurrencyWords'
import { i18n } from '@/Infrastructure/Intl/Intl'

export default Vue.extend({
  name: 'DeclarationsLoteRisco',
  components: {
    StringifiedNumberInput,
    SpeciesFormattedNumberInput,
    InfoTooltip
  },
  props: {
    offer: {
      type: Object as () => Offer
    },
    appraisal: {
      type: String
    }
  },
  data () {
    return {
      formattedPrice: '',
      inputIsValid: false
    }
  },
  computed: {
    stringifiedPrice (): string {
      if (this.inputIsValid) {
        const language = i18n.locale
        const result = new CurrencyWords(language, this.formattedPrice).toString()
        return result
      } else { return '' }
    }
  },
  watch: {
    offer (newValue: Offer, oldValue: Offer) {
      if (newValue !== oldValue) {
        this.formattedPrice = newValue.global.numberBid
      }
    }
  },
  created () {
    if (this.offer !== null) {
      this.formattedPrice = this.offer.global.numberBid
    }
  },
  methods: {
    sendOfferData (): void {
      this.$emit('risco-offer-updated', {
        textBid: this.stringifiedPrice,
        numberBid: this.inputIsValid ? this.formattedPrice : ''
      })
    }
  }
})
